import React from 'react';

function PaperScrap(props){
  const x = Number(props.x);
  const y = Number(props.y);
  const height = Number(props.height);
  const width = Number(props.width);
  return (
    <g id="corkboard-title" transform={`rotate(${props.rotate}, ${x + width/2 - width/20}, ${y + height/150 - height/15})`}>
      <image className='card' xlinkHref={require('../images/web_corkboard_title_tornpaper.png')} x={x} y={y} height={height} width={width} filter="url(#shadow)" />
      <text textAnchor="middle" x={x + width/2} y={y + height/2.2}>{props.label}</text>
      <image xlinkHref={require('../images/thumbtack.png')}
      x={x + width/2 - width/20} y={y + height/150 - height/15} height={39.33} width={39.33}/> 
    </g>
  )
}

export default PaperScrap;


// WEBPACK FOOTER //
// ./src/components/PaperScrap.js